import { useState, useEffect } from 'react';
import type { FilterState } from '../features/orders/components/WorkOrderList';

const STORAGE_KEY = 'dashboardFilters';

export function useDashboardFilters() {
    const [filters, setFilters] = useState<FilterState | undefined>(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : undefined;
        } catch {
            return undefined;
        }
    });

    useEffect(() => {
        if (filters) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
        }
    }, [filters]);

    return [filters, setFilters] as const;
}
